<template>
	<div class="qusetion-wrap clearfix">
		<div class="qusetion-wrapleft">
			<div v-for="(item,index) in qusetionlist" :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'" v-show="questionindex == index">
				<div class="questionTitle">
					<span>{{index+1}}.</span>
					<span v-if="item.topicType == 4">{{item.question | spliceQuestion}}</span>
					<span v-if="item.topicType != 4">{{item.question}}</span>
					<span class="examIng_score warningColor" v-if="taskType">（{{item.score}}分{{!questionsubmit?item.userScore!=null?'，得分'+item.userScore:'，未批改' :''}}）</span>
					<div v-if="item.isFile == '1'" class="filebox">
						<div class="fileboxname">图片/视频：</div>
						<div class="inlinBlock">
							<div class="inlinBlock" :key='file.id' v-for="(file,fileindex) in item.files">
								<video style="width: 150px; height: 150px" :src="baseurl + file.url" v-if="file.url.indexOf('.mp4')>-1" controls="controls" muted="muted"></video>
								<el-image fit="fill" style="width: 150px; height: 150px" :src="baseurl + file.url" :preview-src-list="[baseurl + file.url]" v-else></el-image>
							</div>
						</div>
					</div>
				</div>
				<div v-if="item.topicType == 1">
					<div class="questionAnswers" @click="singleAnswer(it,i,index)" v-for="(it,i) in item.answerlist">
						<div class="questionLabel" :class="!questionsubmit?'questionLabel' + item.chooseRight :''">
							<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
								<div class="inCircle"></div>
							</div>
						</div>
						<div class="inline">
							{{it.label}}.
							<span v-if="it.type == '1'">{{it.value}}</span>
							<div class="inline" v-if="it.type == '2'" @click.stop>
								<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video>
								<el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
							</div>
						</div>
					</div>
				</div>
				<div v-if="item.topicType == 2">
					<div class="questionAnswers" @click="multipleAnswer(it,i,index)" v-for="(it,i) in item.answerlist">
						<div class="questionLabel" :class="!questionsubmit?'questionLabel' + item.chooseRight :''">
							<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
								<div class="inCircle"></div>
							</div>
						</div>
						<div class="inline">
							{{it.label}}.
							<span v-if="it.type == '1'">{{it.value}}</span>
							<div class="inline" v-if="it.type == '2'" @click.stop>
								<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video>
								<el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
							</div>
						</div>
					</div>
				</div>
				<div v-if="item.topicType == 3">
					<div class="questionAnswers" @click="singleAnswer(it,i,index)" v-for="(it,i) in item.answerlist">
						<div class="questionLabel" :class="!questionsubmit?'questionLabel' + item.chooseRight :''">
							<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
								<div class="inCircle"></div>
							</div>
						</div>
						<div class="inline">
							{{it.label}}.
							<span v-if="it.type == '1'">{{it.value}}</span>
							<div class="inline" v-if="it.type == '2'" @click.stop>
								<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video>
								<el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
							</div>
						</div>
					</div>
				</div>
				<div v-if="item.topicType == 4">
					<el-input placeholder="请输入答案，每个答案之间用顿号隔开" v-model="item.userAnswer" :key='item.id' @input="blanksAnswer(index)">
					</el-input>
					<el-alert title="每个答案之间用顿号隔开" type="warning" :closable="false" style='margin: 15px 0 0 0;'>
					</el-alert>
				</div>
				<div v-if="item.topicType == 5">
					<el-input type="textarea" resize="none" :rows="6" placeholder="请输入内容" v-model="item.userAnswer" :key='item.id' @input="blanksAnswer(index)">
					</el-input>
					<div class="fileArrbox clearfix" v-if="item.filearr.length>0">
						<div class="uploadFile" @click.stop="formPreview(file)" v-for="(file,index) in item.filearr">
							<img src="@/images/word.png" />
							<div class="p1">
								{{file.name}}
							</div>
							<div class="p2">
								{{file.size | filesize}}
							</div>
							<i class="el-icon-close closeFile" @click.stop="formFileRemove(file)"></i>
						</div>
						<div class="question_upload" v-if="questionsubmit">
							<el-button @click='uploadAnswer' type="primary" size="small" :disabled='uploadFlag' v-show="item.topicType == 5">
								{{uploadFlag?'正在上传 ':'上传附件'}}
							</el-button>
						</div>
					</div>
				</div>
				<div class="questionFooter questionInfoFooter" v-if="!questionsubmit">
					<div class="questionFooter" v-if="item.topicType == 1 || item.topicType == 2 || item.topicType == 3">
						我的答案：{{item.userAnswer}}&nbsp;&nbsp;
						<i class="iconfont iconcuo" v-if="item.chooseRight == '0'" style="color: #F56C6C;"></i>
						<i class="iconfont icondui" v-if="item.chooseRight == '1'" style="color: #00B43C;"></i>
					</div>
					<div class="questionFooter" v-if="item.topicType == 4">
						我的答案：{{item.userAnswer}}
					</div>
					<div class="questionFooter" v-if="item.topicType == 5">
						<div v-html="getAnswer(item)"></div>
					</div>
					<div class="fileArrbox" v-if="item.userAnswerFilearr && item.userAnswerFilearr.length>0">
						<div class="uploadFile" @click.stop="formPreview(file)" v-for="(file,index) in item.userAnswerFilearr">
							<img src="@/images/word.png" />
							<div class="p1">
								{{file.name}}
							</div>
							<div class="p2">
								{{file.size | filesize}}
							</div>
						</div>
						<div style="clear: both;"></div>
					</div>
					<div class="questionFooter" v-if="item.topicType == 4">
						参考答案：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
					</div>
					<div class="questionFooter" v-if="item.topicType != 4">
						参考答案：{{item.answer}}
					</div>
					<div class="questionFooter" v-if="item.topicType == 5">
						关键词：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
					</div>
					<div class="questionFooter">
						解析：{{item.analysis || '无'}}
					</div>
					<div class="questionFooter" v-show='item.comment'>
						教师评语：{{item.comment }}
					</div>
				</div>
			</div>
		</div>
		<div v-show="false">
			<el-upload :action="action" :limit='1' :multiple='false' :with-credentials='true' accept='.doc,.docx,.mp4,.mp3,.wav' name='file' :file-list="answer_files" :http-request="formRequest">
				<i class="el-icon-plus uploadBox"></i>
			</el-upload>
		</div>
		<el-dialog :title="viewName==''?'预览':viewName" :visible.sync="viewShow" append-to-body>
			<div class="viewIframe">
				<iframe :src="playUrl" v-if="!viewAideoShow"></iframe>
				<audio :src="playUrl" v-if="viewAideoShow" controls="controls"></audio>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="viewShow = false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { putProgress } from '@/utils/oss.js'
	export default {
		props: {
			qusetionlist: Array,
			questionindex: Number,
			questionsubmit: Boolean,
			taskType: Boolean,
		},
		data() {
			return {
				playUrl: '',
				viewName: '',
				viewShow: false,
				viewAideoShow: false,
				viewurl: 'https://view.officeapps.live.com/op/view.aspx?src=',
				action: '',
				uploadFlag: false,
				answer_files: [],
				uploadDate: {},
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			uploadAnswer() {
				$('.uploadBox').click()
			},
			get_name(filename) {
				let pos = filename.lastIndexOf('.')
				let suffix = ''
				if(pos != -1) {
					suffix = filename.substring(0, pos)
				}
				return suffix
			},
			formRequest(files) {
				this.$emit('uploadStatus', true);
				this.uploadFlag = true;
				const file = files.file;
				const key = `vr/stuTopic/${this.getUUID()}/${file.name}`;
				putProgress(key, file).then(res => {
					this.$emit('uploadStatus', false);
					this.uploadFlag = false;
					var fileSize = file.size;
					var fileName = this.get_name(file.name);
					var data = {
						name: fileName,
						size: fileSize,
						url: this.baseurl + key,
					}
					var filearr = [data];
					this.$emit('uploadAnswer', filearr)
					this.formFileClear();
				});
			},
			getUUID() {
				return  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
					let  r = Math.random() * 16 | 0,
						v = c ==  'x'  ? r : (r & 0x3 | 0x8);
					return  v.toString(16);    
				});
			},
			formFileClear() {
				this.answer_files = [];
			},
			formFileRemove() {
				if(this.questionsubmit) {
					this.$emit('formFileRemove')
				}
			},
			formPreview(file) {
				var url = file.url;
				var filetype = file.url.substring(file.url.lastIndexOf('.') + 1);
				this.viewAideoShow = false;
				if(filetype == 'doc' || filetype == 'docx') {
					if((file.size / 1024 / 1024) < 10) {
						var playUrl = this.viewurl + url;
						this.playUrl = playUrl;
						this.viewName = file.name;
						this.viewShow = true;
					} else {
						this.$message({
							type: 'info',
							message: '文件过大，无法在线预览，请查看本地文件',
							title: '提示'
						});
					}
				} else {
					var playUrl = url;
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					if(filetype == 'mp3' || filetype == 'wav') {
						this.viewAideoShow = true;
					}
				}
			},
			singleAnswer(it, i, index) {
				if(this.questionsubmit) {
					this.$emit('singleAnswer', {
						it,
						i,
						index
					})
				}
			},
			multipleAnswer(it, i, index) {
				if(this.questionsubmit) {
					this.$emit('multipleAnswer', {
						it,
						i,
						index
					})
				}
			},
			blanksAnswer(index) {
				this.$forceUpdate();
				if(this.questionsubmit) {
					this.$emit('blanksAnswer', {
						index
					})
				}
			},
			getAnswer(item) {
				if(item.userAnswer) {
					var answerlist = item.answerlist;
					var answerStr = '我的答案：';
					var userAnswer = item.userAnswer;
					answerlist.map(answer => {
						userAnswer = userAnswer.split(answer.value).join('<span style="color: #e64242;">' + answer.value + '</span>');
					})
					return answerStr + userAnswer;
				} else {
					return '';
				}
			},
		},
	}
</script>